import { Layout } from '@/components/layout/Layout';
import { QRCodeDisplay } from '@/components/lunchkort/QRCodeDisplay';
import { CompanyQRCodeDisplay } from '@/components/lunchkort/CompanyQRCodeDisplay';
import { MOCK_CARD, MOCK_COMPANY_CARD } from '@/lib/lunchData';
import { useApp } from '@/context/AppContext';
import { Button } from '@/components/ui/button';
import { RefreshCw, TestTube, Building2 } from 'lucide-react';

const TestLunchkort = () => {
  const { findCardByPhone, findCompanyCardByPhone, lunchCards, companyCards } = useApp();
  
  // Find the current state of the mock cards from context
  const mockCard = findCardByPhone(MOCK_CARD.phoneNumber) || MOCK_CARD;
  const mockCompanyCard = findCompanyCardByPhone(MOCK_COMPANY_CARD.phoneNumber) || MOCK_COMPANY_CARD;

  const handleResetAllCards = () => {
    localStorage.removeItem('lunchCards');
    localStorage.removeItem('companyCards');
    window.location.reload();
  };

  return (
    <Layout>
      <section className="bg-secondary/30 py-12">
        <div className="container-wide mx-auto px-4 text-center">
          <div className="flex items-center justify-center gap-2 mb-4">
            <TestTube size={32} className="text-primary" />
            <h1 className="font-display text-3xl md:text-4xl font-bold text-foreground">
              Testkort
            </h1>
          </div>
          <p className="text-muted-foreground max-w-xl mx-auto">
            Mockade lunchkort för testning. Skanna QR-koderna med kassavyn.
          </p>
        </div>
      </section>

      <section className="section-padding">
        <div className="container-narrow mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            
            {/* Private lunch card */}
            <div className="space-y-6">
              <div className="text-center">
                <div className="inline-block px-3 py-1 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">
                  Privat lunchkort
                </div>
                <QRCodeDisplay card={mockCard} showInstructions />
              </div>

              <div className="card-warm p-4 bg-muted/50">
                <h4 className="font-medium text-foreground mb-2 text-sm">Teknisk info</h4>
                <div className="text-xs font-mono text-muted-foreground space-y-1">
                  <p>ID: {mockCard.id}</p>
                  <p>Telefon: {mockCard.phoneNumber}</p>
                  <p>QR-data: LUNCHCARD|{mockCard.phoneNumber}</p>
                  <p>Luncher kvar: {mockCard.remaining}</p>
                </div>
              </div>
            </div>

            {/* Company lunch card */}
            <div className="space-y-6">
              <div className="text-center">
                <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent/10 text-accent-foreground text-sm font-medium mb-4">
                  <Building2 size={14} />
                  Företagslunchkort
                </div>
                <CompanyQRCodeDisplay card={mockCompanyCard} showInstructions />
              </div>

              <div className="card-warm p-4 bg-muted/50">
                <h4 className="font-medium text-foreground mb-2 text-sm">Teknisk info</h4>
                <div className="text-xs font-mono text-muted-foreground space-y-1">
                  <p>ID: {mockCompanyCard.id}</p>
                  <p>Företag: {mockCompanyCard.companyName}</p>
                  <p>Telefon: {mockCompanyCard.phoneNumber}</p>
                  <p>QR-data: COMPANYCARD|{mockCompanyCard.phoneNumber}</p>
                  <p>Luncher kvar: {mockCompanyCard.remaining}/{mockCompanyCard.total}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Instructions */}
          <div className="max-w-md mx-auto mt-8">
            <div className="card-warm p-6 mb-6">
              <h3 className="font-display text-lg font-semibold text-foreground mb-3">
                Så testar du
              </h3>
              <ol className="space-y-2 text-sm text-muted-foreground">
                <li>1. Öppna kassavyn på en annan enhet eller flik</li>
                <li>2. Klicka "Skanna QR-kod"</li>
                <li>3. Rikta kameran mot någon av QR-koderna ovan</li>
                <li>4. Kortet identifieras automatiskt som privat eller företag</li>
              </ol>
            </div>

            {/* Stats */}
            <div className="card-warm p-4 bg-muted/50 mb-6">
              <h4 className="font-medium text-foreground mb-2 text-sm">Systemstatus</h4>
              <div className="text-xs text-muted-foreground space-y-1">
                <p>Totalt antal privata kort: {lunchCards.length}</p>
                <p>Totalt antal företagskort: {companyCards.length}</p>
              </div>
            </div>

            {/* Reset button */}
            <Button 
              variant="outline" 
              onClick={handleResetAllCards}
              className="w-full"
            >
              <RefreshCw size={16} />
              Återställ alla testkort
            </Button>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default TestLunchkort;
